<!-- 选题变更申请 -->
<template>
  <svg v-if="modelValue == 0" class="notStarted" viewBox="0 0 35.08 35.94">
    <title>选题变更申请</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.54" cy="27.37" rx="17.54" ry="8.57" />
        <ellipse class="cls-2" cx="17.54" cy="27.37" rx="13.57" ry="6.77" />
        <path
          class="cls-3"
          d="M5.28,3.6V2.22a1,1,0,0,1,1-1l13,0a1,1,0,0,1,1,1l0,5.55a1,1,0,0,0,1,1l5.92.06a1,1,0,0,1,1,1v4.5"
        />
        <path class="cls-3" d="M17.15,29H6.41a1.06,1.06,0,0,1-1-1.11V10.36" />
        <line class="cls-4" x1="19.94" y1="1.45" x2="27.79" y2="9.07" />
        <line class="cls-3" x1="9.86" y1="11.63" x2="16.69" y2="11.63" />
        <line class="cls-3" x1="9.86" y1="21.3" x2="16.69" y2="21.3" />
        <line class="cls-3" x1="9.86" y1="16.46" x2="16.69" y2="16.46" />
        <path
          class="cls-3"
          d="M25.27,18.75A5.26,5.26,0,1,1,20.06,24c0-.15,0-.29,0-.43"
        />
        <path
          class="cls-5"
          d="M25,16.11,21.07,18.4a.16.16,0,0,0,0,.28L25,21a.17.17,0,0,0,.25-.14V16.25A.17.17,0,0,0,25,16.11Z"
        />
        <ellipse class="cls-6" cx="5.28" cy="7.13" rx="0.85" ry="0.84" />
      </g>
    </g>
  </svg>
  <svg v-else-if="modelValue == 1" class="inProgress" viewBox="0 0 35.08 35.94">
    <title>选题变更申请</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.54" cy="27.37" rx="17.54" ry="8.57" />
        <ellipse class="cls-2" cx="17.54" cy="27.37" rx="13.57" ry="6.77" />
        <path
          class="cls-3"
          d="M5.28,3.6V2.22a1,1,0,0,1,1-1l13,0a1,1,0,0,1,1,1l0,5.55a1,1,0,0,0,1,1l5.92.06a1,1,0,0,1,1,1v4.5"
        />
        <path class="cls-3" d="M17.15,29H6.41a1.06,1.06,0,0,1-1-1.11V10.36" />
        <line class="cls-4" x1="19.94" y1="1.45" x2="27.79" y2="9.07" />
        <line class="cls-3" x1="9.86" y1="11.63" x2="16.69" y2="11.63" />
        <line class="cls-3" x1="9.86" y1="21.3" x2="16.69" y2="21.3" />
        <line class="cls-3" x1="9.86" y1="16.46" x2="16.69" y2="16.46" />
        <path
          class="cls-3"
          d="M25.27,18.75A5.26,5.26,0,1,1,20.06,24c0-.15,0-.29,0-.43"
        />
        <path
          class="cls-5"
          d="M25,16.11,21.07,18.4a.16.16,0,0,0,0,.28L25,21a.17.17,0,0,0,.25-.14V16.25A.17.17,0,0,0,25,16.11Z"
        />
        <ellipse class="cls-5" cx="5.22" cy="7.19" rx="1.08" ry="1.06" />
      </g>
    </g>
  </svg>
  <svg v-else viewBox="0 0 35.32 37.5">
    <title>选题变更申请</title>
    <g id="图层_2" data-name="图层 2">
      <g id="图层_1-2" data-name="图层 1">
        <ellipse class="cls-1" cx="17.66" cy="28.87" rx="17.66" ry="8.63" />
        <ellipse class="cls-2" cx="17.66" cy="28.87" rx="13.66" ry="6.82" />
        <path
          class="cls-3"
          d="M5.82,3.51V2.16a1,1,0,0,1,1-1l12.69,0a1,1,0,0,1,1,1l0,5.41a1,1,0,0,0,1,1l5.77.06a1,1,0,0,1,1,1v4.39"
        />
        <path class="cls-3" d="M17.4,28.27H6.92a1,1,0,0,1-1-1.08V10.1" />
        <line class="cls-4" x1="20.12" y1="1.41" x2="27.77" y2="8.85" />
        <line class="cls-3" x1="10.29" y1="11.34" x2="16.95" y2="11.34" />
        <line class="cls-3" x1="10.29" y1="20.77" x2="16.95" y2="20.77" />
        <line class="cls-3" x1="10.29" y1="16.05" x2="16.95" y2="16.05" />
        <path
          class="cls-3"
          d="M25.31,18.29a5.12,5.12,0,1,1-5.07,5.12c0-.14,0-.28,0-.42"
        />
        <path
          class="cls-5"
          d="M25.05,15.71l-3.83,2.23a.17.17,0,0,0,0,.28l3.83,2.22a.15.15,0,0,0,.23-.13V15.85A.16.16,0,0,0,25.05,15.71Z"
        />
        <ellipse class="cls-5" cx="5.76" cy="6.61" rx="1.03" ry="1.04" />
      </g>
    </g>
  </svg>
</template>
<script lang="ts" setup>
  withDefaults(
    defineProps<{
      /** 任务执行状态 */
      modelValue: number;
    }>(),
    // 默认值
    { modelValue: 0 }
  );
</script>
<style lang="scss" scoped>
  // 未开始
  .notStarted {
    .cls-1 {
      fill: #f0f7f7;
    }
    .cls-2 {
      fill: #d7e2e2;
    }
    .cls-3 {
      fill: none;
    }
    .cls-3,
    .cls-4,
    .cls-5,
    .cls-6 {
      stroke: #9a9b9b;
      stroke-miterlimit: 10;
    }
    .cls-3,
    .cls-4 {
      stroke-linecap: round;
      stroke-width: 2.4px;
    }
    .cls-4 {
      fill: #1ba586;
    }
    .cls-5,
    .cls-6 {
      fill: #9a9b9b;
    }
    .cls-5 {
      stroke-width: 1.09px;
    }
    .cls-6 {
      stroke-width: 0.81px;
    }
  }
  // 进行中
  .inProgress {
    .cls-1 {
      fill: #f4e4d4;
    }
    .cls-2 {
      fill: #efd0a3;
    }
    .cls-3 {
      fill: none;
    }
    .cls-3,
    .cls-4 {
      stroke: #ed9c24;
      stroke-linecap: round;
      stroke-miterlimit: 10;
      stroke-width: 2.4px;
    }
    .cls-4 {
      fill: #1ba586;
    }
    .cls-5 {
      fill: #ed9c24;
    }
  }
  // 已完成
  .completed {
    .cls-1 {
      fill: #d5ebe9;
    }
    .cls-2 {
      fill: #b8ded9;
    }
    .cls-3 {
      fill: none;
    }
    .cls-3,
    .cls-4,
    .cls-5 {
      stroke: #1ba586;
      stroke-miterlimit: 10;
    }
    .cls-3,
    .cls-4 {
      stroke-linecap: round;
      stroke-width: 2.34px;
    }
    .cls-4,
    .cls-5 {
      fill: #1ba586;
    }
    .cls-5 {
      stroke-width: 0.57px;
    }
  }
</style>
